// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3WwYD","productName":"Table_productName__2yLav"};